<div (click)="buttonOrNameClicked()" class="set-title" [matTooltip]="datasetTooltip" matTooltipClass="dataset-tooltip"
  [matTooltipDisabled]="tooltipDisabled">
  <button mat-icon-button>
    <ng-container *ngIf="icon">
      <mat-icon [svgIcon]="icon"></mat-icon>
    </ng-container>
    <ng-container *ngIf="!icon">
      <ng-container [ngSwitch]="expanded">
        <mat-icon *ngSwitchCase="true" svgIcon="chevron-down"></mat-icon>
        <mat-icon *ngSwitchCase="false" svgIcon="chevron-right"></mat-icon>
      </ng-container>
    </ng-container>
  </button>
  <span class="name">
    {{node.label }}
  </span>
</div>
<div class="unvalidated-dataset" *ngIf="unvalidated">
  <mat-icon class="unvalidated-icon" svgIcon="layers-off-outline"></mat-icon>
</div>
<button mat-icon-button *ngIf="showMenu && isActualDataset" [matMenuTriggerFor]="rasterMenu">
  <mat-icon svgIcon="dots-vertical"></mat-icon>
</button>
<mat-menu #rasterMenu="matMenu">
  <button mat-menu-item (click)="openDatasetMetainfoDialog($event)">
    <mat-icon svgIcon="information-outline"></mat-icon>
    <span>Metadata</span>
  </button>

  <button mat-menu-item *ngIf="isTimeSeriesNode && (authenticated | async)" (click)="extractDataset()">
    <mat-icon svgIcon="database-arrow-right-outline"></mat-icon>
    <span>Extract</span>
  </button>

  <button mat-menu-item *ngIf="(authenticated | async)" (click)="downloadDataset()">
    <mat-icon svgIcon="download-outline"></mat-icon>
    <span>Download</span>
  </button>

  <button mat-menu-item *ngIf="canEditDataset" (click)="navigateToDatasetEditPage()">
    <mat-icon svgIcon="pencil-outline"></mat-icon>
    <span>Edit</span>
  </button>
</mat-menu>
